/**
 * 카카오 키를 되돌린다 — `.env`의 `VITE_KAKAO_*_KEY_ENC`는 **base64(솔트 + 키)**다
 * (사용자 지시 2026-08-25).
 *
 * **난독화이지 암호화가 아니다.** `VITE_` 값은 빌드 산출물에 그대로 박히고 솔트도 이 파일에
 * 있으므로 받아 보는 쪽은 언제든 되돌릴 수 있다. 눈에 띄는 평문을 없애는 것까지가 이것의
 * 몫이고, **실질적인 방어선은 카카오 콘솔의 플랫폼 도메인 제한**이다.
 *
 * FE repo(`src/shared/lib/kakaoKey.ts`)와 **같은 규칙의 사본**이다 — shared 모듈을 만들지
 * 않는다(아키텍처 원칙: FE와 API는 REST contract만 공유한다). 솔트를 바꾸면 양쪽을 함께 고친다.
 */

/** `.env`를 만들 때 쓴 것과 **같은 값**이어야 한다. 바꾸면 `.env` 값도 다시 만든다. */
const SALT = 'haebom.'

/** 키가 없거나 모양이 틀리면 `null` — 부르는 쪽이 그 사실을 화면에 말한다. */
function decode(enc: unknown): string | null {
  if (typeof enc !== 'string' || enc.length === 0) return null

  try {
    const decoded = atob(enc)
    if (!decoded.startsWith(SALT)) return null
    const key = decoded.slice(SALT.length)
    return key.length > 0 ? key : null
  } catch {
    // base64가 아니면 atob이 던진다 — 키가 없는 것과 같이 다룬다.
    return null
  }
}

/** 로컬 REST API(주소 검색)용. */
export function readKakaoRestKey(): string | null {
  return decode(import.meta.env.VITE_KAKAO_REST_KEY_ENC)
}

/** 지도 JS SDK용. **REST 키와 다른 키다** — 콘솔의 같은 앱 안에 따로 있다. */
export function readKakaoJsKey(): string | null {
  return decode(import.meta.env.VITE_KAKAO_JS_KEY_ENC)
}
